/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UserNotificationCategory = "INVESTED" | "PURCHASED" | "SUCCESS" | "%future added value";
export type AllNotificationsQueryVariables = {||};
export type AllNotificationsQueryResponse = {|
  +userNotification: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +created: any,
        +edited: ?any,
        +id: string,
        +user: {|
          +id: any
        |},
        +content: string,
        +icon: ?string,
        +category: UserNotificationCategory,
        +isRead: boolean,
      |}
    |}>
  |}
|};
export type AllNotificationsQuery = {|
  variables: AllNotificationsQueryVariables,
  response: AllNotificationsQueryResponse,
|};
*/


/*
query AllNotificationsQuery {
  userNotification {
    edges {
      node {
        created
        edited
        id
        user {
          id
        }
        content
        icon
        category
        isRead
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "UserNotificationNodeConnection",
    "kind": "LinkedField",
    "name": "userNotification",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserNotificationNodeEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserNotificationNode",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "created",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "edited",
                "storageKey": null
              },
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserType",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v0/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "content",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "icon",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "category",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isRead",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AllNotificationsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AllNotificationsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "787b779ece63388183565187a3a13a72",
    "id": null,
    "metadata": {},
    "name": "AllNotificationsQuery",
    "operationKind": "query",
    "text": "query AllNotificationsQuery {\n  userNotification {\n    edges {\n      node {\n        created\n        edited\n        id\n        user {\n          id\n        }\n        content\n        icon\n        category\n        isRead\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '7888e50cd6a7ad99c6221fc5919f36ff';

module.exports = node;
